import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SupportProgressDialogComponent } from '../support-progress-dialog/support-progress-dialog.component';

@Component({
  selector: 'app-support4-panel',
  templateUrl: './support4-panel.component.html',
  styleUrls: ['./support4-panel.component.scss'],
})
export class Support4PanelComponent {
  @Input() platformInfo: any;
  @Input() problemInfo: any;
  @Input() ticket: any;

  constructor(private dialog: MatDialog) {}

  checkFormDetail() {
    this.dialog.open(SupportProgressDialogComponent, {
      data: this.ticket.id,
      width: '665px',
      panelClass: 'app-dialog',
    });
  }
}
